/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetMetadata200ResponseDataOpengraph } from './GetMetadata200ResponseDataOpengraph'
import {
  GetMetadata200ResponseDataOpengraphFromJSON,
  GetMetadata200ResponseDataOpengraphFromJSONTyped,
  GetMetadata200ResponseDataOpengraphToJSON,
} from './GetMetadata200ResponseDataOpengraph'

/**
 *
 * @export
 * @interface GetMetadata200ResponseData
 */
export interface GetMetadata200ResponseData {
  /**
   *
   * @type {string}
   * @memberof GetMetadata200ResponseData
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof GetMetadata200ResponseData
   */
  description: string
  /**
   *
   * @type {GetMetadata200ResponseDataOpengraph}
   * @memberof GetMetadata200ResponseData
   */
  opengraph: GetMetadata200ResponseDataOpengraph
}

/**
 * Check if a given object implements the GetMetadata200ResponseData interface.
 */
export function instanceOfGetMetadata200ResponseData(
  value: object
): value is GetMetadata200ResponseData {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('description' in value) || value['description'] === undefined)
    return false
  if (!('opengraph' in value) || value['opengraph'] === undefined) return false
  return true
}

export function GetMetadata200ResponseDataFromJSON(
  json: any
): GetMetadata200ResponseData {
  return GetMetadata200ResponseDataFromJSONTyped(json, false)
}

export function GetMetadata200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetMetadata200ResponseData {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    description: json['description'],
    opengraph: GetMetadata200ResponseDataOpengraphFromJSON(json['opengraph']),
  }
}

export function GetMetadata200ResponseDataToJSON(
  value?: GetMetadata200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    description: value['description'],
    opengraph: GetMetadata200ResponseDataOpengraphToJSON(value['opengraph']),
  }
}
